import React from 'react';
import { LogoXcalaWhite } from '../components/LogoXcalaWhite';
import { BoxLogo, LogoImage } from './StyledComponentsMenu';

export const DrawerLogo = ({ open, handleClickHome, activeItem, setActiveItem }) => {
  const LogoX = '../../../assets/images/LogoX.png';

  const handleClick = () => {
    setActiveItem('inicio');
    handleClickHome();
  };

  return (
    <BoxLogo>
      {open ? (
        <LogoXcalaWhite handleClickHome={handleClick} />
      ) : (
        // biome-ignore lint/a11y/useKeyWithClickEvents: <explanation>
        <LogoImage onClick={handleClick} src={LogoX} alt='Logo' />
      )}
    </BoxLogo>
  );
};
